// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7459764b36ebfe452a6f","293":"cafa5cb590c62a4c90e8","518":"a01563ab36f37fc40386","779":"4a7c34a2c65896db4819"}[chunkId] + ".js";
};